// export let baseUrl = `https://bankitruck.com:5203/`;
// export let publicUrl = `https://www.bankitruck.com/home`;
// export let baseUrl = `https://bankitruck.com:5203/`;
 //export let baseUr = `https://bankitruck.com:5202/`;
  export let baseUrl = `https://bankitruck.com:5203/`;
// export let baseUrl = `http://127.0.0.1:4000/`;
 export let publicUrl = `http://localhost:4200/home`;
 